import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CGISeverityModule } from '../cgi-severity/cgi-severity.module';
import { StatusIconModule } from '../status-icon/status-icon.module';
import { PromptuaryCgi } from './promptuary-cgi.component';

@NgModule({
	declarations: [PromptuaryCgi],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FormsModule,
		StatusIconModule,
		CGISeverityModule,
		ReactiveFormsModule,
	],
	exports: [PromptuaryCgi],
	providers: [],
})
export class PromptuaryCGIModule {}
